import { Tabs } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  currentTab: string
  onTabChange: (tab: string) => void
  financialDocumentsPaymentsAvailable: boolean
}

const InvoiceTabs = ({ currentTab, onTabChange, financialDocumentsPaymentsAvailable }: Props) => {
  const tabsData = [
    { id: 'all', label: i18n.t('finance.invoices.list.tabs.all') },
    { id: 'review', label: i18n.t('finance.invoices.list.tabs.pending_to_pay_no_counter') },
    ...(financialDocumentsPaymentsAvailable
      ? [{ id: 'sent_to_pay', label: i18n.t('finance.invoices.list.tabs.sent_to_pay_no_counter') }]
      : []),
    { id: 'paid', label: i18n.t('finance.invoices.list.tabs.paid_no_counter') },
  ]

  return (
    <Tabs currentId={currentTab} onTabClicked={onTabChange}>
      {tabsData.map(({ id, label }) => (
        <Tabs.Tab key={id} id={id} label={label} />
      ))}
    </Tabs>
  )
}

export default InvoiceTabs
